import { z } from "zod";
import { WHEEL_ENGINE_VERSION_DEFAULT, WHEEL_REWARD_TYPES, WHEEL_VISUAL_VARIANT_DEFAULT, } from "./wheel.js";
const leadFieldEnum = z.enum(["email", "phone"]);
export const wheelInteractionSchema = z.union([
    z.object({ type: z.literal("instant") }),
    z.object({
        type: z.literal("lead_capture"),
        requiredFields: z.array(leadFieldEnum).min(1),
    }),
    z.object({ type: z.literal("instant_discount") }),
]);
const rewardTypeSchema = z.enum(WHEEL_REWARD_TYPES);
/**
 * Stored on CampaignVariant.wheelConfig — no visual/rendering fields.
 * rewardValue rules enforced in superRefine (aligned with game-types wheel.ts docs).
 */
export const wheelSegmentSchema = z
    .object({
    id: z.string().min(1),
    label: z.string(),
    weight: z.number().finite().positive(),
    rewardType: rewardTypeSchema,
    rewardValue: z.union([z.string(), z.number()]),
    enabled: z.boolean(),
})
    .superRefine((val, ctx) => {
    const { rewardType, rewardValue } = val;
    if (rewardType === "message" || rewardType === "free_shipping") {
        if (typeof rewardValue !== "string") {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "rewardValue must be a string for message and free_shipping",
                path: ["rewardValue"],
            });
        }
    }
    if (rewardType === "discount_code") {
        if (typeof rewardValue !== "string" || rewardValue.trim().length === 0) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "rewardValue must be a non-empty string for discount_code",
                path: ["rewardValue"],
            });
        }
    }
    if (rewardType === "discount_percent") {
        if (typeof rewardValue !== "number" ||
            !Number.isFinite(rewardValue) ||
            rewardValue < 0 ||
            rewardValue > 100) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "rewardValue must be a number from 0 to 100 for discount_percent",
                path: ["rewardValue"],
            });
        }
    }
    if (rewardType === "points") {
        if (typeof rewardValue !== "number" ||
            !Number.isInteger(rewardValue) ||
            rewardValue < 0) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "rewardValue must be a non-negative integer for points",
                path: ["rewardValue"],
            });
        }
    }
});
/**
 * CampaignVariant.wheelConfig — segments + optional engine/visual metadata.
 * Omitted `engineVersion` / `visualVariant` are defaulted (backward compatible).
 */
export const wheelConfigSchema = z
    .object({
    segments: z.array(wheelSegmentSchema).min(2),
    engineVersion: z.string().optional(),
    visualVariant: z.string().optional(),
    interaction: wheelInteractionSchema.optional(),
})
    .transform((d) => ({
    ...d,
    engineVersion: d.engineVersion ?? WHEEL_ENGINE_VERSION_DEFAULT,
    visualVariant: d.visualVariant ?? WHEEL_VISUAL_VARIANT_DEFAULT,
    interaction: d.interaction ?? { type: "instant" },
}));
//# sourceMappingURL=wheel-config-schema.js.map